<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <div class="sidebar-nav">
        <div class="sidebar-header">
            <div class="img-avatar">
                <avatar :username="user.firstname+' '+user.lastname" :size="80"></avatar>
            </div>
            <!--<img src="static/img/avatars/8.jpg" class="img-avatar" alt="Avatar">-->
            <div><strong>{{user.firstname}} {{user.lastname}}</strong></div>
            <div class="text-muted">
                <small>
                    {{user.authority}}<br />
                    {{user.agency}}
                </small>
            </div>
            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                <button type="button" class="btn btn-link text-lowercase" v-on:click="logout">
                    <i class="icon-logout"></i> Esci
                </button>
            </div>
        </div>
        
        <slot>
            <nav class="sidebar-nav open">
                <ul class="nav">
                    <li class="nav-item">

                        <a class="nav-link" href="#/"><i class="icon-speedometer"></i>Home</a>
                    </li>
                    <li class="nav-item administrator" v-if="isAdministrator || isAdministrative">
                        <a class="nav-link" href="#/ts/export"><i class="icon-cloud-download"></i>Esportazione Fatture Manuali</a>
                    </li>
                    <li class="nav-item administrator" v-if="isAdministrator">
                        <a class="nav-link" href="#/message/list"><i class="icon-directions"></i>Messaggi</a>
                    </li>
                </ul>
            </nav>
        </slot>
    </div>
    
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
    import SidebarNavLabel from './SidebarNavLabel'
    import Avatar from 'vue-avatar'
export default {
        name: 'sidebar',
        computed: {
            user() {
                return this.$store.state.user;
            }, isAdministrator() {
                if (!this.$store.state.user) return false;
                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrator") return true;
                }
                return false;
            }

            , isAdministrative() {
                if (!this.$store.state.user) return false;
                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrative") return true;
                }
                return false;
            }
        },
        props: {
            navItems: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        components: {
            Avatar,
            SidebarFooter,
            SidebarForm,
            SidebarHeader,
            SidebarMinimizer,
            SidebarNavDivider,
            SidebarNavDropdown,
            SidebarNavLink,
            SidebarNavTitle,
            SidebarNavItem,
            SidebarNavLabel
        },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      },

      logout() {
          this.$store.dispatch('logout');
          this.$router.push({ name: 'route-login' });

      }
      
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
